import { render } from "./KyushuOlle.vue?vue&type=template&id=65b5427c"
import script from "./KyushuOlle.vue?vue&type=script&lang=js"
export * from "./KyushuOlle.vue?vue&type=script&lang=js"

import "./KyushuOlle.vue?vue&type=style&index=0&id=65b5427c&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__